import { toComparableTask } from "authoring/routes/project/amends/lib/to-comparable-task.mjs"
import { getComparisonNormalizeString } from "routes/schedule/compare/get-comparison-normalizer"

export function checkAuthoringTaskEquality(t1, t2) {
    if (!t1 || !t2) return false
    if (Boolean(t1.isHeader) !== Boolean(t2.isHeader)) return false
    const normalizeString = getComparisonNormalizeString(t1, t2)
    return (
        JSON.stringify(toNormalizedComparableTask(t1, normalizeString)) ===
        JSON.stringify(toNormalizedComparableTask(t2, normalizeString))
    )
}

function toNormalizedComparableTask(task, normalizeString) {
    const comparable = toComparableTask(task)
    comparable.title = normalizeString(comparable.title ?? "")
    comparable.content = normalizeString(comparable.content ?? "")
    comparable.note = normalizeString(comparable.note ?? "")
    return comparable
}
